import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/NavBar';
import Products from './components/Products';
import PrivateRoute from 'core/components/Routes/PrivateRoute';
import './styles.scss';

const Admin = () => (
    <div className="admin-container">
        <Navbar/>
        <div className="admin-content">
            <Routes>
                <Route
                    path="products/*"
                    element={
                        <PrivateRoute>
                            <Products/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="categories"
                    element={
                        <PrivateRoute>
                            <h1>Categories</h1>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="users"
                    element={
                        <PrivateRoute allowedRoutes={['ROLE_ADMIN']}>
                            <h1>Users</h1>
                        </PrivateRoute>
                    }
                />
            </Routes>
        </div>
    </div>
);

export default Admin;